import { render, staticRenderFns } from "./ReplacementDeleteModal.vue?vue&type=template&id=065fc33b"
import script from "./ReplacementDeleteModal.vue?vue&type=script&lang=js"
export * from "./ReplacementDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports